import React from 'react';

import Text from '../../../components/text/Text';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

/** "Step 2 of 6" for a step screen's header (Screen `headerRight`); nothing without a position. */
const StepCount = ({ position }) => {
	const styles = useThemedStyles(createStyles);
	if (!position) {
		return null;
	}

	return <Text style={styles.text}>{`Step ${position.number} of ${position.total}`}</Text>;
};

const createStyles = ({ ui: { colors, type } }) => ({
	text: {
		...type.secondary,
		color: colors.textSecondary,
		paddingRight: 2,
	},
});

export default StepCount;
